<template>
  <div class="home">
    <div class="wrap">   
      <div class="sign" id="sign">
        <div class="pTitle">
          忘记密码
        </div>
        <div class = "sign-body">
          <div id = "signUp" class="s-form" >
            <form @submit.prevent="" v-show="step1">
              <label>手机号</label>
              <div class="field">  
                <input v-model="user.phone" name="name" type="text" ref="phone">
                <div class="warning" v-show="warnPhone" ref="warn"></div>
              </div>          
              <label for="">验证码</label> 
              <div class="field" style="display:flex;margin-bottom:0">
                <input v-model="user.vertify" name="name" type="text" style="flex:1;margin-right:5px" ref="vertify">
                <button class="btn-code" v-show="!hasCounted" @click="getVertifyCode" ref="getVCode">获取验证码</button>
                <button class="btn-count" v-show="hasCounted">{{count}}秒后重新发送</button>                
              </div>
              <div class="warning" v-show="vertifyTip" ref="vertifyTip"></div>
              <button class="btn btn-primary" @click="nextStep">下一步</button> 
              <router-link to='/home'>
                <button class="btn btn-normal">已有账号，登录</button>
              </router-link> 
            </form>

            <form @submit.prevent="modifyPassword">
              <div v-show="step2">
                <label for="">密码</label>
                <div class="field">
                    <input v-model="user.password" name="name" type="password">
                    <div ref="passwordTip" class="warning"></div>
                </div>
                <label for="">再次输入密码</label>
                <div class="field">
                    <input v-model="user.confirmPassword"  name="name" type="password">
                    <div ref="confirmPassword" class="warning"></div>
                </div>                
                <div id="signUp">
                  <input class="btn btn-primary" style="margin-bottom:6px" type="submit" value="确认">
                  <p v-show="resetSuccess">修改成功!</p>
                </div>    
              </div>
            </form>             
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajaxAPI } from '@/utils/ajaxUtil'
import { HYBIRD_URL } from '@/config/url_config'
export default {
  components: {
  },
  data () {
    return {
      user: {
        phone: '',
        password: '',
        confirmPassword: '',
        vertify: ''
      },
      n: 0,
      isSign: 0,
      count: 60,
      hasCounted: false,
      step1: true,
      step2: false,
      warnPhone: false,
      vertifyTip: false,
      warnSigned: false,
      resetSuccess: false,
      error: true,
      items: [
        {identity: '老师'},
        {identity: '学生'}
      ],
      roomId: ''
    }
  },
  mounted () {
  },
  methods: {
    register () {
      this.isSign = 1
      document.getElementById('sign').style.height = '460px'
    },
    getVertifyCode () {
      let forgetpwdData = this.user
      let _this = this
      _this.count = 60      // 每次倒计时之前需要重置
      let url = `${HYBIRD_URL}/user/forgetpwd/smscode?mobile=${forgetpwdData.phone}`
      _this.vertifyTip = false
      _this.warnPhone = false
      _this.$refs.getVCode.setAttribute('disabled', true)
      if (!forgetpwdData.phone) {
        _this.warnPhone = true
        _this.$refs.warn.innerHTML = '请输入手机号码'
        return false
      }
      if (!(/^1(3|4|5|7|8)\d{9}$/.test(forgetpwdData.phone))) {
        _this.warnPhone = true
        _this.$refs.warn.innerHTML = '请输入正确的手机号码'
        return false
      }
      ajaxAPI('GET', url).then(data => {
        console.log(data.data.status)
        _this.warnPhone = false
        if (data.data.status === 0) {
          _this.hasCounted = true
          _this.countdown = setInterval(function () {
            console.log(_this.count)
            _this.count--
            if (_this.count === 0) {
              clearInterval(_this.countdown)
              _this.hasCounted = false
              _this.$refs.getVCode.innerHTML = '再次发送'
              _this.$refs.getVCode.removeAttribute('disabled')
            } else {
              _this.hasCounted = true
            }
          }, 1000)
        } else {
          _this.warnPhone = true
          _this.hasCounted = false
          _this.$refs.warn.innerHTML = data.data.message
        }
      }).catch(error => {
        console.log(error)
      })
    },
    nextStep () {
      let url = `${HYBIRD_URL}/user/forgetpwd/validateCode`
      let data = {
        mobile: this.user.phone,
        validateCode: this.user.vertify
      }
      this.warnPhone = false
      this.vertifyTip = false
      console.log('data', data)
      if (!this.user.phone) {
        this.warnPhone = true
        this.$refs.warn.innerHTML = '请输入手机号码'
        return false
      }
      if (!this.user.vertify) {
        this.warnPhone = false
        this.vertifyTip = true
        this.$refs.vertifyTip.innerHTML = '请输入验证码'
        return false
      }
      ajaxAPI('POST', url, data).then(data => {
        console.log(data)
        if (data.data.status === '0') {
          this.step1 = false
          this.step2 = true
          clearInterval(this.countdown)
        } else {
          this.vertifyTip = true
          this.$refs.vertifyTip.innerHTML = '请输入正确的验证码'
          console.log(data.data.message)
          this.$refs.tipCode.innerHTML = data.data.message
        }
      }).catch(error => {
        console.log(error)
      })
    },
    modifyPassword () {
      let _this = this
      let userData = {
        mobile: _this.user.phone,
        encrypted_password: _this.user.password,
        validateCode: _this.user.vertify
      }
      let url = `${HYBIRD_URL}/user//forgetpwd/resetPwd`
      if (!userData.encrypted_password) {
        this.$refs.passwordTip.innerHTML = '密码不能为空!'
        this.error = false
        console.log('1')
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(userData.encrypted_password)) {
        this.$refs.passwordTip.innerHTML = '密码必须由数字和字母组成!且长度为6-16位'
        this.error = false
      } else {
        this.$refs.passwordTip.innerHTML = ''
      }
      if (!this.user.confirmPassword) {
        this.$refs.confirmPassword.innerHTML = '密码不能为空!'
        this.error = false
      } else {
        this.$refs.confirmPassword.innerHTML = ''
      }
      if (userData.encrypted_password !== this.user.confirmPassword) {
        this.$refs.confirmPassword.innerHTML = '两次输入的密码不同!'
        this.error = false
      }
      console.log(this.error)
      if (!this.error) {
        return false
      }
      ajaxAPI('POST', url, userData).then(data => {
        console.log(data.data.status)
        if (data.data.status === '0') {
          _this.resetSuccess = true
          _this.$refs.passwordTip.innerHTML = ''
          setTimeout(function () {
            _this.$router.push('home')
          }, 2000)
        }
      }).then(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
  input{
    outline: 0
  }
  .home{
    text-align: center;
    color:#8B9194;  
  }
  .btn-count{
    width:140px;
    height:34px;
    border-radius:20px;
    background:#1FB6FF;
    color:#fff;
    border:0;
    position: relative;
  }
  .btn-code{
    border:0;
    background:#fff;
    color:#1FB6FF;
  }    
  .pTitle{
    text-align:center;
    font-size: 16px;
    font-weight: normal;
    line-height: 60px
  }
</style>



// WEBPACK FOOTER //
// forgetPassword.vue?7bcbaee5